import {
  REQUEST_LINEAR_GRAPH_DATA,
  SET_LINEAR_GRAPH_LOADING,
  SET_LINEAR_GRAPH_MODE,
  SET_LINEAR_GRAPH_DATA,
  SHIFT_LINEAR_GRAPH,
  REQUEST_SUMMARY_GRAPH_DATA,
  SET_SUMMARY_GRAPH_DATA,
  SET_SUMMARY_GRAPH_LOADING,
  SET_SUMMARY_GRAPH_MODE,
  SET_SUMMARY_GRAPH_START_DATE,
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILED,
  CLEAR_ORDERS_STATE,
  UPLOAD_BULK_ORDER_REQUEST,
  UPLOAD_BULK_ORDER_SUCCESS,
  UPLOAD_BULK_ORDER_FAILED,
  CREATE_BULK_ORDER_REQUEST,
  CREATE_BULK_ORDER_FAILED,
  CREATE_BULK_ORDER_SUCCESS,
  BULK_EMAIL_VALIDATION_REQUEST,
  BULK_EMAIL_VALIDATION_SUCCESS,
  BULK_EMAIL_VALIDATION_FAILED,
} from 'features/dashboard/redux/types';
import { LinearGraphReducerType } from 'features/dashboard/redux/createLinearChartReducer';
import { ChartViewMode } from 'features/dashboard/ts/ChartViewMode';
import { LinearChartItem } from 'features/dashboard/ts/LinearCharItem';
import { logoutSuccess } from 'features/auth/redux/actions';
import { RadialChartItem } from 'features/dashboard/ts/RadialChartItem';
import { InputOrder } from 'features/dashboard/ts/InputOrder';
import { SendBulkOrder } from 'features/dashboard/ts/SendBulkOrder';
import { BulkEmailVerificationType } from 'features/dashboard/ts/OrderSummary';

export const requestLinearGraphData = (reducerType: LinearGraphReducerType) => ({
  type: REQUEST_LINEAR_GRAPH_DATA,
  reducerType,
});

export const setLinearGraphMode = (reducerType: LinearGraphReducerType, payload: ChartViewMode) => ({
  type: SET_LINEAR_GRAPH_MODE,
  reducerType,
  payload,
});

export const setLinearGraphLoading = (reducerType: LinearGraphReducerType, payload: boolean) => ({
  type: SET_LINEAR_GRAPH_LOADING,
  reducerType: reducerType,
  payload,
});

export const setLinearGraphData = (reducerType: LinearGraphReducerType, payload: LinearChartItem[]) => ({
  type: SET_LINEAR_GRAPH_DATA,
  reducerType,
  payload,
});

export const shiftLinearGraphData = (reducerType: LinearGraphReducerType, payload: 'previous' | 'next') => ({
  type: SHIFT_LINEAR_GRAPH,
  reducerType,
  payload,
});

export const requestSummaryGraphData = () => ({
  type: REQUEST_SUMMARY_GRAPH_DATA,
});

export const setSummaryGraphMode = (payload: ChartViewMode) => ({
  type: SET_SUMMARY_GRAPH_MODE,
  payload,
});

export const setSummaryGraphLoading = (payload: boolean) => ({
  type: SET_SUMMARY_GRAPH_LOADING,
  payload,
});

export const setSummaryGraphData = (payload: RadialChartItem[]) => ({
  type: SET_SUMMARY_GRAPH_DATA,
  payload,
});

export const setSummaryGraphStartDate = (payload: Date) => ({
  type: SET_SUMMARY_GRAPH_START_DATE,
  payload,
});

export const createOrderRequest = (payload: InputOrder) => ({
  type: CREATE_ORDER_REQUEST,
  payload,
});

export const createOrderSuccess = () => ({
  type: CREATE_ORDER_SUCCESS,
});

export const createOrderFailed = (error: string) => ({
  type: CREATE_ORDER_FAILED,
  payload: {
    error,
  },
});

export const createBulkOrderRequest = (payload: InputOrder[]) => ({
  type: CREATE_BULK_ORDER_REQUEST,
  payload,
});

export const createBulkOrderSuccess = () => ({
  type: CREATE_BULK_ORDER_SUCCESS,
});

export const createBulkOrderFailed = (error: string) => ({
  type: CREATE_BULK_ORDER_FAILED,
  payload: {
    error,
  },
});

export const uploadBulkOrderRequest = (payload: FormData) => ({
  type: UPLOAD_BULK_ORDER_REQUEST,
  payload,
});

export const uploadBulkOrderSuccess = (payload: SendBulkOrder) => ({
  type: UPLOAD_BULK_ORDER_SUCCESS,
  payload,
});

export const uploadBulkOrderFailed = (error: string) => ({
  type: UPLOAD_BULK_ORDER_FAILED,
  payload: {
    error,
  },
});

export const bulkEmailValidationRequest = (payload: FormData) => ({
  type: BULK_EMAIL_VALIDATION_REQUEST,
  payload,
});

export const bulkEmailValidationSuccess = (payload: Array<BulkEmailVerificationType>) => ({
  type: BULK_EMAIL_VALIDATION_SUCCESS,
  payload,
});

export const bulkEmailValidationFailed = (error: string) => ({
  type: BULK_EMAIL_VALIDATION_FAILED,
  payload: {
    error,
  },
});

export const clearOrdersState = () => ({
  type: CLEAR_ORDERS_STATE,
});

export type DashboardActions = ReturnType<
  | typeof logoutSuccess
  | typeof requestLinearGraphData
  | typeof setLinearGraphMode
  | typeof setLinearGraphLoading
  | typeof setLinearGraphData
  | typeof shiftLinearGraphData
  | typeof requestSummaryGraphData
  | typeof setSummaryGraphMode
  | typeof setSummaryGraphLoading
  | typeof setSummaryGraphData
  | typeof setSummaryGraphStartDate
  | typeof createOrderRequest
  | typeof createOrderSuccess
  | typeof createOrderFailed
  | typeof createBulkOrderRequest
  | typeof createBulkOrderSuccess
  | typeof createBulkOrderFailed
  | typeof uploadBulkOrderRequest
  | typeof uploadBulkOrderSuccess
  | typeof uploadBulkOrderFailed
  | typeof clearOrdersState
  | typeof bulkEmailValidationRequest
  | typeof bulkEmailValidationSuccess
  | typeof bulkEmailValidationFailed
>;

export type LinearGraphAction = {
  reducerType?: LinearGraphReducerType;
  apiUrl?: string;
};
